<template>
    <re-b-modal ref="modal" large hide-footer
                :header="modalHeader">
        <b-table small striped bordered responsive show-empty
                 class="mb-0"
                 :busy="loading"
                 :items="rows"
                 :fields="fields"
                 :empty-text="$t('label.em.asset.emArchFixedAsset.noHistory')">
            <template #table-busy>
                <div class="text-center text-muted py-3">
                    <i class="fa fa-fw fa-spinner fa-spin"></i>
                </div>
            </template>
            <template #cell(fieldName)="{value}">
                {{ fieldLabel(value) }}
            </template>
            <template #cell(source)="{value}">
                {{ sourceLabel(value) }}
            </template>
        </b-table>
    </re-b-modal>
</template>

<script>
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import emCommonApiMixin from "@/mixin/em/common/api";

/**
 * 固定资产档案变更历史弹窗（验收 #5 后半：自动记录信息变更历史并生成时间戳）
 * <p>
 * 新建档案不产生历史（历史只记「变更」）；非财务用户拿不到 4 个财务字段的变更行——后端已过滤。
 */
export default {
    name: "EmArchFixedAssetHistoryModal",
    components: {ReBModal},
    mixins: [emCommonApiMixin],
    data() {
        return {
            loading: false,
            rows: [],
            asset: null,
        }
    },
    computed: {
        baseApi() {
            return process.env.VUE_APP_EM_ARCHIVE_URL + '/emArchFixedAsset';
        },
        modalHeader() {
            let title = this.$t('title.em.asset.emArchFixedAsset.history');
            if (!this.asset) {
                return title;
            }
            return `${title} - ${this.asset.assetNo || ''} / ${this.asset.subAssetNo || ''}`;
        },
        fields() {
            return [
                {
                    key: 'operateTime',
                    label: this.$t('label.em.asset.emArchFixedAsset.history.operateTime'),
                    thStyle: {width: '160px'}
                },
                {
                    key: 'fieldName',
                    label: this.$t('label.em.asset.emArchFixedAsset.history.fieldName'),
                    thStyle: {width: '140px'}
                },
                {key: 'oldValue', label: this.$t('label.em.asset.emArchFixedAsset.history.oldValue')},
                {key: 'newValue', label: this.$t('label.em.asset.emArchFixedAsset.history.newValue')},
                {
                    key: 'operator',
                    label: this.$t('label.em.asset.emArchFixedAsset.history.operator'),
                    thStyle: {width: '110px'}
                },
                {
                    key: 'source',
                    label: this.$t('label.em.asset.emArchFixedAsset.history.source'),
                    thStyle: {width: '110px'}
                },
            ];
        },
    },
    methods: {
        open(row) {
            if (!row || !row.id) {
                return;
            }
            this.asset = row;
            this.rows = [];
            this.$refs.modal.showModal();
            this.load(row.id);
        },

        load(id) {
            this.loading = true;
            // api/get 拿到的就是 body（EmResponseUtils.success 裸透传）
            this.$_emApiMixin_get(`${this.baseApi}/history/${id}`)
                    .then(res => this.rows = res || [])
                    .finally(() => this.loading = false);
        },

        /**
         * 历史里的 fieldName 是实体属性名；没有对应 i18n 时原样显示
         */
        fieldLabel(fieldName) {
            if (!fieldName) {
                return '';
            }
            let key = `label.em.asset.emArchFixedAsset.entity.${fieldName}`;
            let text = this.$t(key);
            return text === key ? fieldName : text;
        },

        sourceLabel(source) {
            if (!source) {
                return '';
            }
            let key = `label.em.asset.emArchFixedAsset.source.${source}`;
            let text = this.$t(key);
            return text === key ? source : text;
        },
    }
}
</script>

<style scoped>
</style>
